import * as actions from './transactions.actions';
import { TransactionsData, TransactionsDetailsResponsePayload, TransactionsFilter, TransactionsForPDFData } from './transactions.models';
import { DatesInterval } from '../../global/interfaces';

import { isNullOrUndefined } from 'util';
import { PaginationInfo } from 'atlas-pagination';

export interface State {
  loading: boolean;
  dataLoading: boolean;
  dates?: DatesInterval;
  data: TransactionsData[];
  details: TransactionsDetailsResponsePayload;
  mobile: TransactionsData;
  mobilePagination: PaginationInfo;
  filter: TransactionsFilter;
  forPDF: TransactionsForPDFData;
  pagination: PaginationInfo;

}

export const initialState: State = {
  loading: false,
  dataLoading: false,
  dates: undefined,
  data: [],
  details: {
    total: 0,
    data: []
  },
  mobile: {
    total: 0,
    fund: undefined,
    transactions: []
  },
  mobilePagination: {
    page: 1,
    itemsByPage: 10,
    total: 0
  },
  filter: {
    funds: [],
    from: '',
    to: ''
  },
  forPDF: {
    loading: false,
    data: [],
  },
  pagination: {
    page: 1,
    itemsByPage: 10,
    total: 0
  }
};

export function reducer(state: State = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.ActionTypes.LOAD_TRANSACTIONS_DATES:
      return { ...state, loading: true, dates: undefined };
    case actions.ActionTypes.LOAD_TRANSACTIONS_DATES_SUCCESS:
      return { ...state, loading: false, dates: action.payload };
    case actions.ActionTypes.LOAD_TRANSACTIONS_DATES_FAILED:
      return { ...state, loading: false, dates: undefined };

    case actions.ActionTypes.LOAD_TRANSACTIONS:
      return { ...state, dataLoading: true, data: [] };
    case actions.ActionTypes.LOAD_TRANSACTIONS_SUCCESS:
      return { ...state, dataLoading: false, data: action.payload };
    case actions.ActionTypes.LOAD_TRANSACTIONS_FAILED:
      return { ...state, dataLoading: false, data: [] };

    case actions.ActionTypes.LOAD_TRANSACTIONS_FOR_PDF:
      return { ...state, forPDF: { loading: true, data: [] } };
    case actions.ActionTypes.LOAD_TRANSACTIONS_FOR_PDF_SUCCESS:
      return { ...state, forPDF: { loading: false, data: action.payload } };
    case actions.ActionTypes.LOAD_TRANSACTIONS_FOR_PDF_FAILED:
      return { ...state, forPDF: { loading: false, data: [] } };

    case actions.ActionTypes.LOAD_TRANSACTIONS_DETAILS:
      return { ...state, loading: true, details: { total: 0, data: [] } };
    case actions.ActionTypes.LOAD_TRANSACTIONS_DETAILS_SUCCESS:
      return { ...state, loading: false, details: action.payload };
    case actions.ActionTypes.LOAD_TRANSACTIONS_DETAILS_FAILED:
      return { ...state, loading: false, details: { total: 0, data: [] } };

    case actions.ActionTypes.LOAD_TRANSACTIONS_MOBILE:
      return { ...state, loading: true };

    /**
     * This data mapping is necessary in order to append transactions to data set
     * instead of overriding it for mobile devices
     */
    case actions.ActionTypes.LOAD_TRANSACTIONS_MOBILE_SUCCESS:
      return {
        ...state,
        loading: false,
        mobile: {
          total: !isNullOrUndefined(action.payload) &&
            !isNullOrUndefined(action.payload.data) &&
            action.payload.data.length > 0 ? action.payload.data[0].total : 0,
          fund: !isNullOrUndefined(action.payload) &&
            !isNullOrUndefined(action.payload.data) &&
            action.payload.data.length > 0 ? action.payload.data[0].fund : undefined,
          transactions: !isNullOrUndefined(action.payload) && !isNullOrUndefined(action.payload.data) && action.payload.data.length > 0 ? [
            ...state.mobile.transactions,
            ...action.payload.data[0].transactions
          ] : [...state.mobile.transactions]
        }
      };
    case actions.ActionTypes.LOAD_TRANSACTIONS_MOBILE_FAILED:
      return { ...state, loading: false, details: { total: 0, data: [] } };
    case actions.ActionTypes.SET_TRANSACTIONS_MOBILE_PAGINATION:
      return { ...state, mobilePagination: action.payload };
    case actions.ActionTypes.RESET_TRANSACTIONS_MOBILE_PAGINATION:
      return { ...state, mobilePagination: { ...initialState.mobilePagination } };
    case actions.ActionTypes.RESET_TRANSACTIONS_MOBILE:
      return { ...state, mobile: { ...initialState.mobile } };

    case actions.ActionTypes.SET_TRANSACTIONS_FILTER:
      return { ...state, filter: action.payload };
    case actions.ActionTypes.SET_TRANSACTIONS_FILTER_FUNDS:
      return { ...state, filter: { ...state.filter, funds: action.payload } };
    case actions.ActionTypes.SET_TRANSACTIONS_FILTER_FROM:
      return { ...state, filter: { ...state.filter, from: action.payload } };
    case actions.ActionTypes.SET_TRANSACTIONS_FILTER_TO:
      return { ...state, filter: { ...state.filter, to: action.payload } };

    case actions.ActionTypes.RESET_TRANSACTIONS_DATA:
      return { ...initialState };
    case actions.ActionTypes.RESET_TRANSACTIONS_FILTER:
      return { ...state, filter: initialState.filter };
    case actions.ActionTypes.SET_TRANSACTIONS_DETAILS_PAGINATION:
      return { ...state, pagination: action.payload };
    default:
      return state;
  }
}
